import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Common/Icon';

const LandingFinalCTA = React.memo(({ onSignup }) => (
  <section className="landing-final-cta" id="start">
    <div className="landing-template-frame landing-final-frame">
      <img src="/landing/footer-foliage.jpg" alt="" aria-hidden="true" loading="lazy" />
      <div className="landing-final-copy">
        <h2>Your life is the lab. Start your first loop.</h2>
        <button type="button" className="landing-btn landing-btn--primary" onClick={onSignup}>
          Start your first experiment
          <Icon name="arrow-right" size={15} />
        </button>
      </div>
    </div>
  </section>
));

LandingFinalCTA.propTypes = {
  onSignup: PropTypes.func.isRequired,
  onUpgradeBeliever: PropTypes.func,
  onUpgradeLifetime: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  checkoutPendingTier: PropTypes.string,
};

LandingFinalCTA.displayName = 'LandingFinalCTA';

export default LandingFinalCTA;
